import { emitFB, emitGA } from './modules/marketing';
import { emitLinkedIn } from './GA';

$('.thirdwatch-form').each(function(index, form) {
  form.onsubmit = function(e) {
    e.preventDefault();
    var $form = $(this);
    var $button = $form.find('button');
    var origText = $button.html();
    $button.prop('disabled', 'true').html('Please Wait...');
    $(this)
      .find('input[name="ref_url"]')
      .remove();
    $(this).append(
      '<input type="hidden" name="ref_url" value="' +
        window.location.href.split('?')[0] +
        '" /> '
    );
    var action = this.action;
    var zapierJson = $(this).serialize();
    function zapier() {
      if (window.razorpayAnalytics) {
        emitGA(
          'Thirdwatch - Start Trial',
          'Form Submitted',
          'Start 1 - Month Free Trial'
        );
        emitFB('thirdwatch_form_submit');
        emitFB('thirdwatch_trialform_submit');
        emitLinkedIn('2517921');
      }

      return $.ajax({
        method: 'post',
        url: action,
        data: zapierJson,
        complete: function(r) {
          $button.prop('disabled', false).html(origText);
        }
      });
    }

    var name = $(".thirdwatch-form input[name='name']").val(),
      email = $(".thirdwatch-form input[name='email']").val(),
      phone = $(".thirdwatch-form input[name='phone']").val(),
      query = $(".thirdwatch-form input[name='reason']").val(),
      website = $(".thirdwatch-form input[name='website']").val();

    function thirdwatchApi() {
      return $.ajax({
        method: 'post',
        url: 'https://api.thirdwatch.ai/neo/v1/auth/contactus',
        data:
          'name=' +
          name +
          '&email=' +
          email +
          '&phone=' +
          phone +
          '&query=' +
          query +
          '&website=' +
          website,
        complete: function(r) {
          $button.prop('disabled', false).html(origText);
        }
      });
    }

    $.when(zapier(), thirdwatchApi()).done(function() {
      $form[0].reset();
      $form.parents('.modal:eq(0)').addClass('success');
    });
  };
});

var originalRzpAnalytics = window.rzpAnalytics;

window.rzpAnalytics = function(data, callback) {
  if (typeof callback !== 'function') {
    callback = function() {};
  }

  if (data.fbevent) {
    razorpayAnalytics.track('fb', data.fbevent);
  }

  originalRzpAnalytics(data, callback);
};
